import { useMemo } from "react";
import { getDefaultOption } from "../../../../../../../helpers/forms/select.js";
const usePassengersRow = (props)=>{
    const { passenger  } = props;
    const selectedOptions = useMemo(()=>{
        if (passenger.selectedOptions) {
            return passenger.selectedOptions;
        }
        if (passenger.options) {
            const defaultSelectedOption = getDefaultOption(passenger.options);
            const finalSelectedOptions = [];
            for(let i = 0; i < passenger.value; i++){
                finalSelectedOptions.push(defaultSelectedOption?.value);
            }
            return finalSelectedOptions;
        }
        return [];
    }, [
        passenger.options,
        passenger.selectedOptions,
        passenger.value
    ]);
    return {
        selectedOptions
    };
};
export default usePassengersRow;

//# sourceMappingURL=usePassengersRow.js.map